<main @fade>
<nb-card [nbSpinner]="loading">
    <nb-card-header *ngIf="!isModal && editMode === false" i18n="@@Creating"><a
      [routerLink]="absolutePath">{{ title }}</a> / Добавление
    </nb-card-header>
    <nb-card-header *ngIf="!isModal && editMode === true" i18n="@@Updating"><a
      [routerLink]="absolutePath">{{ title }}</a> / {{ editName }}</nb-card-header>

    <nb-card-header *ngIf="deleted"><span i18n="@@RecordDeletedNoTags" class="badge text-bg-secondary">запись удалена</span>
      &nbsp;
      <button *ngIf="deleted" (click)="restore()" i18n-nbTooltip="@@Restore" nbTooltip="Восстановить" nbButton status="control" size="small">
        <nb-icon icon="repeat-outline"></nb-icon>
      </button>
    </nb-card-header>

    <nb-card-body>

      <div class="row">
        <div [ngClass]="isModal ? 'col-lg-12' : 'col-lg-7 n-part-left'">
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="mb-3">
              <label class="form-label" for="validatorHeader" i18n="@@ValidatorNameLabel">Название валидатора *</label>
              <input
                nbInput
                fullWidth
                [ngClass]="{'is-invalid': header.invalid && (header.touched || header.dirty)}"
                formControlName="header"
                id="validatorHeader"
                i18n-placeholder="@@ValidatorNameLabel"
                placeholder="Название валидатора"
              />
              <div *ngIf="header.invalid && (header.dirty || header.touched)">
                <div *ngIf="header.hasError('required')" class="text-danger" i18n="@@ValidatorHeaderEmptyError">
                  Поле обязательно для заполнения.
                </div>
                <div *ngIf="header.hasError('notUnique')" class="text-danger" i18n="@@FeatureValueRequiredError">
                  Название должно быть уникальным
                </div>
              </div>
            </div>

            <div formGroupName="featureType">
              <div class="mb-3">
                <label class="form-label" for="featureTypeId" i18n="@@FeatureTypeLabel">Тип *</label>
                <ng-select [items]="featureTypes"
                           [loading]="loadingFeatureTypes"
                           [clearable]="false"
                           formControlName="featureTypeId"
                           id="featureTypeId"
                           placeholder="Поиск типа характеристики"
                           appendTo="body"
                           bindLabel="header"
                           i18n-placeholder="@FeatureTypeSearch"
                           bindValue="id">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <span [title]="item.header" [innerHTML]="item.header" style="white-space: pre"></span>
                  </ng-template>
                </ng-select>

                <div class="invalid-feedback"
                     *ngIf="featureTypeId.invalid && (featureTypeId.touched || featureTypeId.dirty)"
                     i18n="@@ValidatorHeaderEmptyError">
                  Поле обязательно для заполнения.
                </div>
              </div>

              <div class="mb-3" *ngIf="showMultipleSelectFormField">
                <nb-toggle status="basic" formControlName="multiple" class="me-3">Множественный список</nb-toggle>
              </div>
            </div>

            <div formGroupName="content">
              <div class="row rowWithMargin" formGroupName="multipleSelectValidator"
                   *ngIf="showMultipleSelectValidators">
                <div class="col-sm-6">
                  <div class="mb-3">
                    <label class="form-label" for="validatorMinValuesNumber" i18n="@@ValidatorMinValuesNumberLabel">Минимальное
                      количество значений</label>
                    <input
                      nbInput
                      fullWidth
                      formControlName="minValuesNumber"
                      id="validatorMinValuesNumber"
                      i18n-placeholder="@@ValidatorMinValuesNumberLabel"
                      placeholder="Минимальное количество значений"
                      type="number"
                      [min]="0"
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="mb-3">
                    <label class="form-label" for="validatorMaxValuesNumber" i18n="@@ValidatorMaxValuesNumberLabel">Максимальное
                      количество значений</label>
                    <input
                      nbInput
                      fullWidth
                      formControlName="maxValuesNumber"
                      id="validatorMaxValuesNumber"
                      i18n-placeholder="@@ValidatorMaxValuesNumberLabel"
                      placeholder="Максимальное количество значений"
                      type="number"
                      [min]="1"
                    />
                  </div>
                </div>
              </div>

              <div formGroupName="numberValidator" *ngIf="showNumberValidators">
                <div class="mb-3">
                  <nb-toggle status="basic" formControlName="isInteger">Целое</nb-toggle>
                </div>
                <div class="row rowWithMargin">
                  <div class="col-sm-6">
                    <div class="mb-3">
                      <label class="form-label" for="validatorMin" i18n="@@ValidatorMinLabel">Минимальное значение</label>
                      <input
                        nbInput
                        fullWidth
                        formControlName="minValue"
                        id="validatorMin"
                        i18n-placeholder="@@ValidatorMinLabel"
                        placeholder="Минимальное значение"
                        type="number"
                      />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="mb-3">
                      <label class="form-label" for="validatorMax" i18n="@@ValidatorMaxLabel">Максимальное
                        значение</label>
                      <input
                        nbInput
                        fullWidth
                        formControlName="maxValue"
                        id="validatorMax"
                        i18n-placeholder="@@ValidatorMaxLabel"
                        placeholder="Максимальное значение"
                        type="number"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div formGroupName="intervalValidator" *ngIf="showIntervalValidators">
                <div class="mb-3">
                  <nb-toggle status="basic" formControlName="isInteger">Целое</nb-toggle>
                </div>
                <h4>Нижняя граница</h4>
                <div class="row rowWithMargin" formGroupName="lowerBoundary">
                  <div class="col-sm-6">
                    <div class="mb-3">
                      <label class="form-label" for="intervalValidator_lowerMin" i18n="@@ValidatorMinLabel">Минимальное значение</label>
                      <input
                        nbInput
                        fullWidth
                        formControlName="minValue"
                        id="intervalValidator_lowerMin"
                        i18n-placeholder="@@ValidatorMinLabel"
                        placeholder="Минимальное значение"
                        type="number"
                      />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="mb-3">
                      <label class="form-label" for="intervalValidator_lowerMax" i18n="@@ValidatorMaxLabel">Максимальное
                        значение</label>
                      <input
                        nbInput
                        fullWidth
                        formControlName="maxValue"
                        id="intervalValidator_lowerMax"
                        i18n-placeholder="@@ValidatorMaxLabel"
                        placeholder="Максимальное значение"
                        type="number"
                      />
                    </div>
                  </div>
                </div>
                <h4>Верхняя граница</h4>
                <div class="row rowWithMargin" formGroupName="upperBoundary">
                  <div class="col-sm-6">
                    <div class="mb-3">
                      <label class="form-label" for="intervalValidator_upperMin" i18n="@@ValidatorMinLabel">Минимальное значение</label>
                      <input
                        nbInput
                        fullWidth
                        formControlName="minValue"
                        id="intervalValidator_upperMin"
                        i18n-placeholder="@@ValidatorMinLabel"
                        placeholder="Минимальное значение"
                        type="number"
                      />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="mb-3">
                      <label class="form-label" for="intervalValidator_upperMax" i18n="@@ValidatorMaxLabel">Максимальное
                        значение</label>
                      <input
                        nbInput
                        fullWidth
                        formControlName="maxValue"
                        id="intervalValidator_upperMax"
                        i18n-placeholder="@@ValidatorMaxLabel"
                        placeholder="Максимальное значение"
                        type="number"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="row rowWithMargin" formGroupName="htmlValidator" *ngIf="showHtmlValidators">
                <div class="col-sm-6">
                  <div class="mb-3">
                    <label class="form-label" for="validatorHtmlMinLength" i18n="@@ValidatorMinLengthLabel">Минимальное
                      количество символов</label>
                    <input
                      nbInput
                      fullWidth
                      formControlName="minLength"
                      id="validatorHtmlMinLength"
                      i18n-placeholder="@@ValidatorMinLengthLabel"
                      placeholder="Минимальное количество символов"
                      type="number"
                      [min]="0"
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="mb-3">
                    <label class="form-label" for="validatorHtmlMaxLength" i18n="@@ValidatorMaxLengthLabel">Максимальное
                      количество символов</label>
                    <input
                      nbInput
                      fullWidth
                      formControlName="maxLength"
                      id="validatorHtmlMaxLength"
                      i18n-placeholder="@@ValidatorMaxLengthLabel"
                      placeholder="Максимальное количество символов"
                      type="number"
                      [min]="1"
                    />
                  </div>
                </div>
              </div>

              <div formGroupName="stringValidator" *ngIf="showStringValidators">
                <div class="mb-3">
                  <label class="form-label" for="typeValidator" i18n="@@StringTypeValidatorLabel">Валидатор *</label>
                  <ng-select [items]="stringValidatorTypes"
                             [closeOnSelect]="true"
                             formControlName="typeValidator"
                             id="typeValidator"
                             placeholder="Тип"
                             appendTo="body"
                             bindLabel="header"
                             i18n-placeholder="@StringTypeValidatorLabel"
                             bindValue="id">
                  </ng-select>
                </div>

                <div formGroupName="customValidator" *ngIf="showCustomStringValidators">
                  <div *ngIf="!showRegexpFormField">
                    <div class="row rowWithMargin">
                      <div class="col-sm-6">
                        <div class="mb-3">
                          <label class="form-label" for="validatorMinLength" i18n="@@ValidatorMinLengthLabel">Минимальное
                            количество символов</label>
                          <input
                            nbInput
                            fullWidth
                            formControlName="minLength"
                            id="validatorMinLength"
                            i18n-placeholder="@@ValidatorMinLengthLabel"
                            placeholder="Минимальное количество символов"
                            type="number"
                            [min]="0"
                          />
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="mb-3">
                          <label class="form-label" for="validatorMaxLength" i18n="@@ValidatorMaxLengthLabel">Максимальное
                            количество символов</label>
                          <input
                            nbInput
                            fullWidth
                            formControlName="maxLength"
                            id="validatorMaxLength"
                            i18n-placeholder="@@ValidatorMaxLengthLabel"
                            placeholder="Максимальное количество символов"
                            type="number"
                            [min]="1"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="mb-3">
                      <nb-toggle status="basic" formControlName="useDigits">Использовать цифры</nb-toggle>
                    </div>

                    <div class="mb-3">
                      <nb-toggle status="basic" formControlName="useCharacters">Использовать буквы</nb-toggle>
                    </div>

                    <div class="row rowWithMargin" formGroupName="characters" *ngIf="showCharactersFieldsFormField">
                      <div class="col-sm-6">
                        <div class="mb-3">
                          <label class="form-label" for="alphabets" i18n="@@AlphabetsLabel">Алфавиты *</label>
                          <ng-select [items]="getAlphabets()"
                                     [multiple]="true"
                                     [clearable]="true"
                                     [closeOnSelect]="false"
                                     formControlName="alphabets"
                                     id="alphabets"
                                     placeholder="Алфавиты"
                                     appendTo="body"
                                     bindLabel="header"
                                     i18n-placeholder="@AlphabetsSearch"
                                     bindValue="id">
                          </ng-select>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="mb-3">
                          <label class="form-label" for="charactersCases" i18n="@@CharactersCaseLabel">Регистр букв *</label>
                          <ng-select [items]="getCharacterCases()"
                                     [clearable]="true"
                                     [multiple]="true"
                                     [closeOnSelect]="false"
                                     formControlName="charactersCases"
                                     id="charactersCases"
                                     placeholder="Регистр букв"
                                     appendTo="body"
                                     bindLabel="header"
                                     i18n-placeholder="@CharactersCaseSearch"
                                     bindValue="id">
                          </ng-select>
                        </div>
                      </div>
                    </div>

                    <div class="mb-3">
                      <nb-toggle status="basic" formControlName="useSymbols">Использовать символы</nb-toggle>
                    </div>

                    <div class="mb-3" *ngIf="showSymbolsFormField">
                      <label class="form-label" for="symbols" i18n="@@SymbolsLabel">Символы *</label>
                      <ng-select [items]="getSymbols()"
                                 [multiple]="true"
                                 [clearable]="true"
                                 [closeOnSelect]="false"
                                 formControlName="symbols"
                                 id="symbols"
                                 placeholder="Выберите символы"
                                 appendTo="body"
                                 bindLabel="header"
                                 i18n-placeholder="@SymbolsSearch"
                                 bindValue="id">
                      </ng-select>
                    </div>

                  </div>

                  <div class="mb-3">
                    <nb-toggle status="basic" formControlName="useRegexp">Применить регулярное выражение</nb-toggle>
                  </div>

                  <div class="mb-3" *ngIf="showRegexpFormField">
                    <label class="form-label" for="validatorRegexp" i18n="@@ValidatorRegexpLabel">Регулярное выражение
                      *</label>
                    <input
                      nbInput
                      fullWidth
                      formControlName="regexp"
                      id="validatorRegexp"
                      i18n-placeholder="@@ValidatorRegexpLabel"
                      placeholder="Регулярное выражение"
                    />
                  </div>
                </div>

              </div>
            </div>

            <div class="mb-3" *ngIf="showNumberValidators || showStringValidators || showIntervalValidators">
              <label class="form-label" for="valueExample" i18n="@@ValidatorNameLabel">Пример значения *</label>
              <input
                nbInput
                fullWidth
                [ngClass]="{'is-invalid': example.invalid && (example.touched || example.dirty)}"
                formControlName="example"
                id="valueExample"
                i18n-placeholder="@@ValidatorNameLabel"
                placeholder="Пример"
              />
              <div class="invalid-feedback" *ngIf="example.invalid && (example.touched || example.dirty)">
                <div *ngIf="example.hasError('required')" class="text-danger" i18n="@@FeatureValueRequiredError">
                  Поле обязательно для заполнения
                </div>
                <div *ngIf="example.hasError('pattern')" class="text-danger" i18n="@@FeatureValueIncorrectError">
                  Не корректное значение
                </div>
                <div *ngIf="example.hasError('min')" class="text-danger" i18n="@@FeatureValueMinError">
                  Минимальное значение {{example.errors.min.min}}
                </div>
                <div *ngIf="example.hasError('max')" class="text-danger" i18n="@@FeatureValueMaxError">
                  Превышено максимальное значение: {{example.errors.max.max}}
                </div>
                <div *ngIf="example.hasError('notInteger') && isNumberFeatureType()" class="text-danger" i18n="@@FeatureValueNotIntegerError">
                  Число должно быть целым
                </div>
                <div *ngIf="example.hasError('notInteger') && isIntervalFeatureType()" class="text-danger" i18n="@@FeatureValueNotIntegerError">
                  Нижняя и верхняя границы должны быть целыми числами
                </div>
                <div *ngIf="example.hasError('lowerGtUpperBoundary') && isIntervalFeatureType()" class="text-danger" i18n="@@FeatureValueLowerGtUpperBoundaryError">
                  Нижняя граница больше верхней
                </div>
                <div *ngIf="example.hasError('lowerMin')" class="text-danger" i18n="@@FeatureValueLowerMinError">
                  Минимальное значение нижней границы {{example.errors.lowerMin.min}}
                </div>
                <div *ngIf="example.hasError('lowerMax')" class="text-danger" i18n="@@FeatureValueLowerMaxError">
                  Превышено максимальное значение нижней границы: {{example.errors.lowerMax.max}}
                </div>

                <div *ngIf="example.hasError('upperMin')" class="text-danger" i18n="@@FeatureValueUpperMinError">
                  Минимальное значение верхней границы {{example.errors.upperMin.min}}
                </div>
                <div *ngIf="example.hasError('upperMax')" class="text-danger" i18n="@@FeatureValueUpperMaxError">
                  Превышено максимальное значение верхней границы: {{example.errors.upperMax.max}}
                </div>
                <div *ngIf="example.hasError('url')" class="text-danger" i18n="@@FeatureValueUrlError">
                  Не корректное значение адреса
                </div>
                <div *ngIf="example.hasError('email')" class="text-danger" i18n="@@FeatureValueEmailError">
                  Не корректное значение адреса электронной почты
                </div>
                <div *ngIf="example.hasError('minlength')" class="text-danger" i18n="@@FeatureValueMinLengthError">
                  Минимум {{ example.errors.minlength.requiredLength }} символов
                </div>
                <div *ngIf="example.hasError('maxlength')" class="text-danger" i18n="@@FeatureValueMaxLengthError">
                  Превышен лимит символов: {{ example.errors.maxlength.actualLength }}
                  из {{ example.errors.maxlength.requiredLength }}
                </div>
                <div *ngIf="example.hasError('stringContent')">
                  <div [ngClass]="example.errors.stringContent.hasNotNumber ? 'text-danger' : 'text-success'" i18n="@@FeatureValueHasNotNumberError" *ngIf="stringCustomValidatorValue.useDigits">
                    Поле должно содержать хотя бы 1 цифру!
                  </div>
                  <div [ngClass]="example.errors.stringContent.hasNotCharacters ? 'text-danger' : 'text-success'" i18n="@@FeatureValueHasNotCharactersError" *ngIf="stringCustomValidatorValue.useCharacters">
                    Поле должно содержать хотя бы 1 букву ({{example.errors.stringContent.allowedAlphabets.join(', ')}}) ({{example.errors.stringContent.allowedCharactersCases.join(', ')}})
                  </div>
                  <div [ngClass]="example.errors.stringContent.hasNotSymbols ? 'text-danger' : 'text-success'" i18n="@@FeatureValueHasNotSymbolsError" *ngIf="stringCustomValidatorValue.useCharacters">
                    Поле должно содержать хотя бы 1 символ ({{example.errors.stringContent.allowedSymbols.join(', ')}})!
                  </div>
                  <div [ngClass]="example.errors.stringContent.hasOtherSymbols ? 'text-danger' : 'text-success'" i18n="@@FeatureValueHasOtherSymbolsError">
                    Поле не должно содержать других символов
                  </div>
                </div>
              </div>
            </div>
            <button nbButton status="primary" type="submit" [disabled]="form.invalid" i18n>
              Сохранить
            </button>
            &nbsp;
            <button *ngIf="isModal" (click)="modalClose()" nbButton status="basic" type="button"
                    i18n="@@Close">Закрыть
            </button>

            <button [routerLink]="absolutePath" nbButton status="basic" type="button" i18n
                    *ngIf="showListButton">Отмена
            </button>

          </form>
        </div>
      </div>
    </nb-card-body>

  </nb-card>
</main>
